import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { displayConsoleLog, displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, screenCaptureAnalytics } from "../../../../utils/Utils";
import { countryListRequest, stateListRequest, cityListRequest } from '../../../../redux/user/user.action'
import { userBusinessListRequest } from '../../../../redux/business/business.action'
import { addBusinessLocationRequest, addBusinessLocationRequestStatus } from '../../../../redux/business-location/businessLocation.action'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../../utils/AppConstants";
import Select from 'react-select'
import CommonButton from "../../../../components/button/common-button/commonButton";
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ButtonRow from "../../../../components/button/button-row/buttonRow";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../../components/input/common-input-float-full/commonInputFloatFull";
import FormFieldLabel from "../../../../components/label/form-field-label/formFieldLabel";
import { CurrencyLabel } from "../../../../utils/CurrencyLabel";
import Modal from 'react-bootstrap/Modal';

const AddLocationScreen = props => {
    const [countryDropdown, setCountryDropdown] = useState();
    const [stateDropdown, setStateDropdown] = useState();
    const [cityDropdown, setCityDropdown] = useState();
    const [countryCode, setCountryCode] = useState('')
    const [name, setName] = useState('')
    const [address, setAddress] = useState('')
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { user, countryListSuccess, countryListError, stateListSuccess, stateListError,
        cityListSuccess, cityListError, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { addBusinessLocationSuccess, addBusinessLocationError, addBusinessLocationReqStatus } = useSelector(state => state.businessLocation)
    const [taxType, setTaxType] = useState('')
    const [taxNumber, setTaxNumber] = useState('')
    const [currencyDropdown, setCurrencyDropdown] = useState()
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch({ type: APP_CONSTANTS.RESET_STATE_CITY })
        dispatch(countryListRequest())
        if (isLoggedInUserBusiness(user) === true) {
            const data = {
                userId: user.data.userDetails.userId
            }
            dispatch(userBusinessListRequest(data))
        }
    }, [])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(countryListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(countryListError)) {
            setLoading(false)
        }
    }, [countryListSuccess, countryListError])

    useEffect(() => {
        if (!isEmpty(stateListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(stateListError)) {
            setLoading(false)
        }
    }, [stateListSuccess, stateListError])

    useEffect(() => {
        if (!isEmpty(cityListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(cityListError)) {
            setLoading(false)
        }
    }, [cityListSuccess, cityListError])

    const fetchStateList = (countryId) => {
        setLoading(true)
        const data = {
            countryId: countryId
        }
        dispatch(stateListRequest(data))
    }

    const fetchCityList = (countryId, stateId) => {
        setLoading(true)
        const data = {
            countryId: countryId,
            stateId: stateId
        }
        dispatch(cityListRequest(data))
    }

    useEffect(() => {
        if (addBusinessLocationReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addBusinessLocationReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addBusinessLocationError.message)
        }

        if (addBusinessLocationReqStatus?.length) {
            dispatch(addBusinessLocationRequestStatus(''))
        }
    }, [addBusinessLocationSuccess, addBusinessLocationError, addBusinessLocationReqStatus])

    const clearFields = () => {
        setName('')
        setTaxType('')
        setTaxNumber('')
        setShowSuccessModal(false)
    }

    const handleNewLocationAddClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    const submitHandler = () => {
        if (isEmpty(name)) {
            displayErrorToast('Location name cannot be blank')
        } else if (isLoggedInUserBusiness(user) === true && isNull(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isEmpty(address)) {
            displayErrorToast('Location address cannot be blank')
        } else if (isNull(countryDropdown)) {
            displayErrorToast('Location country is not selected')
        } else if (isNull(stateDropdown)) {
            displayErrorToast('Location state is not selected')
        } else if (isNull(cityDropdown)) {
            displayErrorToast('Location state is not selected')
        } else if (isEmpty(currencyDropdown)) {
            displayErrorToast('Location currency not selected')
        } else {
            setLoading(true)
            const data = {
                name: name,
                businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                productCode: user.data.userDetails.productCode,
                country: countryDropdown.name,
                state: stateDropdown.name,
                city: cityDropdown.name,
                countryCode: countryDropdown.iso2,
                stateCode: stateDropdown.iso2,
                address: address,
                currencyLabel: currencyDropdown.code,
                currencySymbol: currencyDropdown.symbol,
                currencyRegion: currencyDropdown.region
            }
            if (!isEmpty(taxType)) {
                data.taxType = taxType
            }
            if (!isEmpty(taxNumber)) {
                data.taxNumber = taxNumber
            }
            dispatch(addBusinessLocationRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <div className="mt-2">
                    <ScreenLabel label='Add Location' />
                </div>
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new business location' />
                    <CommonInputFloatFull
                        type="name"
                        id="name"
                        placeholder="Location Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        isRequired={true}
                    />
                    {isLoggedInUserBusiness(user) === true && !isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                        className='select-full-width-no-border'
                        value={selectedBusiness}
                        getOptionLabel={e => e.businessName}
                        getOptionValue={e => e}
                        options={userBusinessListSuccess.data}
                        placeholder='Select Business'
                        onChange={e => setSelectedBusiness(e)} />}
                    {isLoggedInUserBusiness(user) === true && !isEmpty(userBusinessListError) && <div className="content-error">{userBusinessListError.message}</div>}
                    <FormFieldLabel label='Select Currency' />
                    {CurrencyLabel && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={currencyDropdown}
                        getOptionLabel={e => `${e.currency} (${e.symbol})`}
                        getOptionValue={e => e}
                        options={CurrencyLabel}
                        placeholder='Select Currency'
                        onChange={e => {
                            setCurrencyDropdown(e)
                        }}
                    />}
                    {/* <FormFieldLabel label='Tax Information' />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type="text"
                            id="taxType"
                            placeholder="Tax Type"
                            value={taxType}
                            onChange={e => setTaxType(e.target.value)}
                        />
                        <CommonInputFloatHalf
                            type="text"
                            id="taxNumber"
                            placeholder="Tax Number"
                            value={taxNumber}
                            onChange={e => setTaxNumber(e.target.value)}
                        />
                    </CommonInputRow> */}
                    <FormFieldLabel label='Address Information' />
                    <CommonInputFloatFull
                        type="name"
                        id="address"
                        placeholder="Location Address"
                        value={address}
                        onChange={e => setAddress(e.target.value)}
                        isRequired={true}
                        isSubtext={true}
                        subText='Street address only'
                    />
                    {countryListSuccess && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={countryDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={countryListSuccess}
                        placeholder='Select Country'
                        onChange={e => {
                            setCountryDropdown(e);
                            setCountryCode(e.iso2)
                            fetchStateList(e.iso2)
                        }} />}
                    {stateListSuccess && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={stateDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={stateListSuccess}
                        placeholder='Select State'
                        onChange={e => {
                            setStateDropdown(e);
                            fetchCityList(countryCode, e.iso2)
                        }} />}
                    {cityListSuccess && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={cityDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={cityListSuccess}
                        placeholder='Select City'
                        onChange={e => {
                            setCityDropdown(e);
                        }} />}
                    <ButtonRow>
                        <CommonButton label='Submit'
                            onClick={() => submitHandler()} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{addBusinessLocationSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another location?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleNewLocationAddClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddLocationScreen